import script from "./studentgy.vue?vue&type=script&setup=true&lang=js"
export * from "./studentgy.vue?vue&type=script&setup=true&lang=js"

import "./studentgy.vue?vue&type=style&index=0&id=2532b680&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2532b680"]])

export default __exports__